import React, { useEffect, useState } from 'react'
import Logo from './Logo.jsx';
import styled from 'styled-components';
import { FiInstagram } from 'react-icons/fi'
import { BsFacebook, BsWhatsapp } from 'react-icons/bs'
import WellcomeSlider from './WellcomeSlider.jsx';
// import firebaseFunctions from './firebase';
import { db, collection, getDocs } from './firebase';

// Now you can access the Firebase functions using firebaseFunctions object
// const { db,collection, doc, getDoc, setDoc, addDoc } = firebaseFunctions;


const HeadContainer = styled.div`
     /* background: #000000;
  background: -webkit-linear-gradient(75deg, #000000 0%, #ffffff 100%);
  background: linear-gradient(75deg, #000000 0%, #ffffff 100%); */
`
const ParContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 1rem;

`
const ParBox = styled.div`
    cursor: pointer;
    padding: 00.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 5.5rem;
    padding-right:00.5rem;
    padding-left:00.5rem;
    border: 1px solid #c2c2c2;
    border-radius:4px ;

    :hover{
        background-color: #eee;
    }

`
const ParSection = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`
const IconContainer = styled.div`
    width: 4rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
`
const Icon = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`
const Text = styled.span`
    font-size: 1.2rem;
    font-weight: bold;
    /* color: #d29904 ; */
`

const Footer = styled.div`
padding: 00.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

`
const FooterContent = styled.div`
    width: 60%;
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    /* flex-wrap: wrap; */
    align-items: center;
`
const FooterItem = styled.div`
    display: flex;
    width: 10rem;
    align-items: center;
    cursor: pointer;
    padding-bottom: 1rem;
`
const IG = styled(FiInstagram)`
    font-size: 1.1rem;
    margin-right: 00.75rem;
`
const FB = styled(BsFacebook)`
    font-size: 1.1rem;
    margin-right: 00.75rem;
`
const Wa = styled(BsWhatsapp)`
    font-size: 1.1rem;
    margin-right: 00.75rem;
`
const SliderContainer = styled.div`
/* margin-top: 3.5rem; */
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    /* height: 15rem; */
    /* height: ; */
`

export default function Main() {

  const [data, setData] = useState({
    belForn: [],
    mashawi: [],
    mokabelatBered: [],
    mokabelatSokhon: [],
    nayeh: [],
    salatat: [],
    wajbat: [],
    beverages: [],
    shisha: [],
  });
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch data from Firestore for each category
        const belFornSnapshot = await getDocs(collection(db, 'Foods', 'belForn', 'belFornCollection'));
        const mashawiSnapshot = await getDocs(collection(db, 'Foods', 'mashawi', 'mashawiCollection'));
        const mokabelatBeredSnapshot = await  getDocs(collection(db, 'Foods', 'mokabelatBered', 'mokabelatBeredCollection'));
        const mokabelatSokhonSnapshot = await  getDocs(collection(db, 'Foods', 'mokabelatSokhon', 'mokabelatSokhonCollection'));
        const nayehSnapshot = await  getDocs(collection(db, 'Foods', 'nayeh', 'nayehCollection'));
        const salatatSnapshot = await  getDocs(collection(db, 'Foods', 'salatat', 'salatatCollection'));
        const wajbatSnapshot = await  getDocs(collection(db, 'Foods', 'wajbat', 'wajbatCollection'));
      // /Beverages /beverages/beveragesCollection
      // 
        const beveragesSnapshot = await  getDocs(collection(db, 'Drinks', 'drinks', 'drinkCollection'));
        // /Shishas/shishas/shishaCollection
        const shishaSnapshot = await  getDocs(collection(db, 'Shishas', 'shishas', 'shishaCollection'));

        // Fetch other categories similarly...

        // Process the snapshot data and update state
        const belFornData = belFornSnapshot.docs.map(doc => doc.data());
        const mashawiData = mashawiSnapshot.docs.map(doc => doc.data());
        const  mokabelatBeredData = mokabelatBeredSnapshot.docs.map(doc => doc.data());
        const  mokabelatSokhonData = mokabelatSokhonSnapshot.docs.map(doc => doc.data());
        const   nayehData = nayehSnapshot.docs.map(doc => doc.data());
        const   salatatData = salatatSnapshot.docs.map(doc => doc.data());
        const   wajbatData = wajbatSnapshot.docs.map(doc => doc.data());
        const   beveragesData = beveragesSnapshot.docs.map(doc => doc.data());
        const   shishaData = shishaSnapshot.docs.map(doc => doc.data());
        // Process other categories similarly...

        setData({
          belForn: belFornData,
          mashawi: mashawiData,
          mokabelatBered: mokabelatBeredData,
          mokabelatSokhon: mokabelatSokhonData,
          nayeh: nayehData,
          salatat: salatatData,
          wajbat: wajbatData,
          beverages: beveragesData,
          shisha: shishaData,
          // Populate other categories here...
        });
        
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []); // Run once on component mount
  // Log the initial state of data
useEffect(() => {
  console.log("Initial Data Fetched: ", data);
}, [data]); // Run once on component mount


    const categories = [   
       
        { name: 'اراكيل ', items: data.shisha.sort( (a, b) => a.index - b.index)
        // [
        //   { name: 'معسل ', price: 5 },
        //   { name: 'تبديل راس', price: 4 },
        //   { name: 'نكهة', price: 6 },
        //   { name: 'عجمي ', price: 9 },
        
        // ]
      },
        { name: 'مرطبات', items: data.beverages.sort( (a, b) => a.index - b.index)
        // [
         
        //     { name: ' مشروبات غازية', price: 1 },
        //     { name: 'لبن عيران', price: 1 },
        //     { name: 'بيريه', price: 4 },
        //     { name: 'مياه معدنية صغيرة', price: 1 },
        //     { name: 'مياه معدنية كبيرة', price: 1 },
        //     { name: 'ليموناضة ', price: 1.5 },
        //   ]
        },
        { name: 'لحمة نية', items: data.nayeh.sort( (a, b) => a.index - b.index)
        //  [
        //     { name: ' لوحة السندس', price: 25 },
        //     { name: 'لوحة نية', price: 18 },
        //     { name: ' ملسة', price: 5.5 },
        //     { name: ' فراكة', price: 5.5 },
        //     { name: 'فراكة و ملسة', price: 5.8 },
        //     { name: 'كبة نية', price: 5.5 },
        //     { name: 'لحمة علسيخين', price: 5.8 },
        //     { name: ' سودة غنم', price: 6 },
        //     { name: 'كفتة نية', price: 5.5 },
        //   ]
        },
        { name: 'مشاوي', items: data.mashawi.sort( (a, b) => a.index - b.index)
        // [
        //     { name: ' جاط مشاوي السندس', price: 34 },
        //     { name: ' جاط مشاوي مشكل', price: 24 },
        //     { name: ' جاط لحم مشوي غنم', price: 28 },
        //     { name: ' جاط مشاوي غنم فتايل أو هبرة', price: 30 },
        //     { name: ' جاط كفتة', price: 24 },
        //     { name: ' جاط كباب حلبي', price: 28 },
        //     { name: ' جاط ريش مشوي', price: 28 },
        //     { name: ' جاط طاووق ', price:20 },
        //     { name: 'فروج مسحب ', price:16 },
          
        //   ]
        },
        { name: 'وجبات', items: data.wajbat.sort( (a, b) => a.index - b.index)
        // [
        //     { name: ' وجبة مشاوي مشكل', price: 8 },
        //     { name: 'وجبة شقف', price: 9 },
        //     { name: 'وجبة كفتة', price: 8 },
        //     { name: 'وجبة كباب حلبي', price: 9 },
        //     { name: "وجبة ريش", price: 9 },
        //     { name: "وجبة عرايس", price: 6 },
        //     { name: "وجبة نخاعات مشوية ", price: 7 },
        //     { name: 'وجبة طاووق', price: 7},
        //     { name: 'وجبة كرسبي ', price: 7 },
        //     { name: 'وجبة اسكالوب', price: 7 },
        //   ]
        },
        { name: 'بالفرن   ', items: data.belForn.sort( (a, b) => a.index - b.index)
        // [
        //     { name: 'ك شقف غنم ', price: 28 },
        //     { name: ' ك شقف عجل ', price: 19 },
        //     { name: ' ك لحم بعجين غنم', price: 28 },
        //     { name: '  ك لحم بعجين عجل', price: 19 },
        //     { name: '  ك لحم بعجين عجل وغنم', price: 24 },
        //     { name: ' ك لحم بعجين عجل وغنم', price: 30 }
        //   ]
        },
        { name: 'مقبلات', items: 
        [
            { name: 'حمص ', price: 3.5 },
            { name: 'متبل ', price: 3.9 },
            { name: 'هندبة', price: 3.5 },
            { name: 'ورق عنب', price: 3.5 },
            { name: 'لبنة مثومة', price: 3.5 }
          ]
        },
        { name: 'سلطات', items: [
            { name: 'تبوله', price: 3.6 },
            { name: 'جاط تبوله', price: 5.5 },
            { name: 'فتوش', price: 4 },
            { name: 'جاط فتوش', price: 5.9 },
            { name: 'سلطة عربية', price: 3.6 },
            { name: 'جاط سلطة عربية', price: 5.5 },
            { name: 'سلطة روكا', price: 3.6 },
            { name: 'جاط سلطة روكا', price: 5.5 },
            { name: 'سلطة زعتر ', price: 3.6 },
            { name: 'جاط سلطة زعتر ', price: 5.5 },
          ]},
      ];
    const Mains = [
        
        
        {label: 'shisha',title: 'اراكيل' , icon: "/assets/icons/shisha.png", content:[categories[0]]},
        {label: 'drink',title:'مشروبات' , icon: "/assets/icons/drink.png" , content:[categories[1]]} , 
        {label: 'food',title: 'مأكولات' , icon: "/assets/icons/food.png" ,content:[categories[2],categories[3],categories[4],categories[5],categories[6],categories[7],]}, 
        
    ]
    const Foods = [
        { name: 'لحمة نية', items: data.nayeh.sort( (a, b) => a.index - b.index)
        // [
        //     { name: ' لوحة السندس', arName: "Law7at Al-Sondos" , price: 37 },
        //     { name: 'لوحة نية',  arName: "Law7et Nayeh" , price: 29 },
        //     { name: ' ملسة',  arName: "Malseh" , price: 8 },
        //     { name: ' فراكة',  arName: "Frakeh" , price: 8 },
        //     { name: 'فراكة و ملسة',  arName: "Frakeh & Malseh" , price: 9 },
        //     { name: 'كبة نية',  arName: "Kebbe Nayeh" , price: 8 },
        //     { name: 'لحمة علسيخين',  arName: "La7me 3al Si5en" , price: 10 },
        //     { name: ' سودة غنم',  arName: "Sawda Ghanam" , price: 10 },
        //     { name: 'كفتة نية',  arName: "Kafta Nayeh" , price: 8 },
        //     { name: 'فتيله نيه مقطعة ',  arName: "Ftileh Nayeh M2ata3a" , price: 11 },
        //   ]
        },
        { name: 'مشاوي', items: data.mashawi.sort( (a, b) => a.index - b.index)
        // [
        //     { name: ' جاط مشاوي السندس', arName: "Mahsawi Al-Sondos" ,price: 53 },
        //     { name: ' جاط مشاوي مشكل', arName: "Mahsawi Mshakal" ,price: 35 },
        //     { name: ' جاط لحم مشوي غنم', arName: "La7em Mashwi Ghanam" ,price: 38 },
        //     { name: ' جاط مشاوي غنم فتايل أو هبرة', arName: "Ghanam Fatayer/Habara" ,price: 45 },
        //     { name: ' جاط كفتة', arName: "Kafta" ,price: 35 },
        //     { name: 'جاط عرايس كفتة', arName: "3arayes Kafta" ,price: 35 },
        //     { name: ' جاط كباب السندس',arName: "Kabab Al-Sondos" , price: 37},
        //     { name: ' جاط كباب حلبي',arName: "Kabab 7alabi" , price: 38},
        //     { name: ' جاط كباب خشخاش',arName: "Kabab 5ash5ash" , price: 38},
        //     { name: ' جاط ريش مشوي',arName: "Riyash Mashwi" , price: 39 },
        //     { name: ' جاط طاووق ',arName: "Tawouk" , price: 28 },
        //     { name: 'فروج مسحب ',arName: "Farouj Msa7ab" , price:22 },
        //   ]
        },
        { name: 'وجبات', items: data.wajbat.sort( (a, b) => a.index - b.index)
        // [
        //     { name: ' وجبة مشاوي مشكل',arName: "Mashawi Mix" , price: 15 },
        //     { name: 'وجبة شقف',arName: "Shekaf" , price: 17 },
        //     { name: 'وجبة كفتة',arName: "Kafta" , price: 15 },
        //     { name: 'وجبة شقف فتايل',arName: "Shekaf Fatayel" , price: 19 },
        //     { name: 'وجبات كباب السندس',arName: "kabab Al-Sondos" , price: 16 },
        //     { name: 'وجبة كباب حلبي',arName: "Kabab 7alabi" , price: 17 },
        //     { name: "وجبة ريش",arName: "Riyash" , price: 18},
        //     { name: "وجبة عرايس",arName: "3arayes" , price: 13 },
        //     { name: "وجبة نخاعات مشوية ",arName: "N5a3at Mashwiya" , price: 11 },
        //     { name: 'وجبة طاووق',arName: "Tawouk" , price: 13},
        //     { name: 'وجبة كرسبي ',arName: "Crispy" , price: 12 },
        //     { name: 'وجبة اسكالوب',arName: "Escalope" , price: 13 },
        //   ]
        },
        { name: 'بالفرن   ', items: data.belForn.sort( (a, b) => a.index - b.index)
        // [
        //     { name: 'ك شقف غنم ', arName: "K Shekaf Ghanam" ,price: 37 },
        //     { name: ' ك شقف عجل ', arName: "K Shekaf 3ejel" ,price: 32 },
        //     { name: ' ك كفتة ', arName: "K kafta" ,price: 34 },
        //     { name: ' ك لحم بعجين غنم',arName: "K La7me B3ajeen Ghanam" , price: 37 },
        //     { name: '  ك لحم بعجين عجل', arName: "K La7me B3ajeen 3ejel " ,price: 25 },
        //     { name: '  ك لحم بعجين عجل وغنم', arName: "K La7me B3ajeen Mix" ,price: 31 },
        //     { name:  'ك لحمة بعجين علسيخ غنم', arName: "K La7me B3ajeen 3al Si5" ,price: 42 }
        //   ]
        },
          { name: 'مقبلات ساخنة', items: data.mokabelatSokhon.sort( (a, b) => a.index - b.index)
          // [
          //   { name: ' بطاطا مقلية ', arName: "Batata Makliya" ,price: 4},
          //   { name: 'جاط بطاطا مقلية ', arName: "Jat Batata Makliya" ,price: 6},
          //   { name: 'بطاطا حارة  ',arName: "Batata 7ara" , price: 4.5},
          //   { name: 'جاط بطاطا حارة ',arName: "Jat Batat 7ara" , price: 6},
          //   { name: 'حمص مع لحمة ',arName: "Hommos Ma3 La7me" , price: 11},
          //   { name: ' كبة مقلية ',arName: "Kebe Makliya" , price: 5},
          //   { name: 'سودة غنم مقلي ', arName: "Sawdet Ghanam Makli" ,price: 12},
          //   { name: 'سودة دجاج ',arName: "Sawdet Djaj" , price: 5.5},
          //   { name: 'مقانق مقلي ',arName: "Makanek Makli" , price: 8},
          //   { name: ' سجق مقلي ',arName: "Sojok Makli" , price: 8},
          //   { name: 'جوانح بروفنسال ',arName: "Jawane7 Profensal" , price: 4.5},
          //   { name: 'فطاير سبانخ',arName: "Fatayer Sabene5" , price: 4},
          //   { name: 'فتايل بالفطر والبصل ',arName: "Fatayel Bel Fotor wel Basal" , price: 10 },
          //   { name: ' رقائق جبنة', arName: "Rkakat Jebne" ,price: 5 },
          //   { name: 'معجنات مشكل ', arName: "Mo3ajanat Mshakal" ,price: 9 },
          //   { name: ' نخاعات مقلية عدد 2', arName: "N5a3at Makliya x2" ,price: 10 },
          //   { name: ' سمبوسك لحمة', arName: "Sambusek La7me" ,price: 4.5 },
            
          // ]
        },
        { name: 'مقبلات باردة ', items: data.mokabelatBered.sort( (a, b) => a.index - b.index)
        // [
        //     { name: 'حمص ', arName: "Hommos" ,price: 4},
        //     { name: 'متبل ', arName: "Mtabal" ,price: 4.5 },
        //     { name: 'هندبة', arName: "Hendbeh" ,price: 5 },
        //     { name: 'ورق عنب', arName: "Warak 3enab" ,price: 5 },
        //     { name: 'لبنة مثومة', arName: "Labne Mtawame" ,price: 4.5 },
        //     { name: 'طاجن', arName: "Tajen" ,price: 6},
        //     { name: 'كبة بندورة', arName: "Tajen" ,price: 4},
        //   ]
        },
        { name: 'سلطات', items: data.salatat.sort( (a, b) => a.index - b.index)
        // [
        //     { name: 'تبوله', arName: "Tabouleh" , price: 4 },
        //     { name: 'جاط تبوله', arName: "Jat Tabouleh" , price: 6 },
        //     { name: 'فتوش', arName: "Fatoush" , price: 4.5 },
        //     { name: 'جاط فتوش',arName: "Jat Fatoush" ,  price: 6.5 },
        //     { name: 'سلطة عربية',arName: "Salata 3arabiya" ,  price: 4 },
        //     { name: 'جاط سلطة عربية', arName: "Jat Salat 3arabiya" , price: 6 },
        //     { name: 'سلطة روكا', arName: "Salatat Rokka" , price: 4 },
        //     { name: 'جاط سلطة روكا', arName: "Jat Salatat Roka" , price: 6 },
        //     { name: 'سلطة زعتر ',arName: "Salatat Za3tar" ,  price: 4 },
        //     { name: 'جاط سلطة زعتر ',arName: "Jat Salatat Za3tar" ,  price: 6 },
        //   ]
        },
    ]
    const Drinks =  { name: 'مرطبات', items: data.beverages.sort( (a, b) => a.index - b.index)
    // [
         
    //     { name: ' مشروبات غازية', nameAr: "Soft Drinks" , price: 2 },
    //     { name: 'لبن عيران', nameAr: "Laban Iran" , price: 2 },
    //     { name: 'بيريه', nameAr: "Perie" , price: 4 },
    //     { name: 'مياه معدنية صغيرة', nameAr: "Water S" , price: 1 },
    //     { name: 'مياه معدنية كبيرة', nameAr: "Water L" , price: 2 },
    //     { name: ' مياه معدنية كبيرة زجاج', nameAr: "Water L Glass" , price: 2.5 },
    //     { name: 'ليموناضة ', nameAr: "Lemonade" , price: 3 },
    //     { name: 'ليموناضة مع نعنع ', nameAr: "Minted Lemonade" , price: 3.5 },
    //   ]
    }
    const Shisha = { name: 'اراكيل ', items: data.shisha.sort( (a, b) => a.index - b.index)
    // [
    //     { name: 'معسل ', price: 5 },
    //     { name: 'تبديل راس', price: 4 },
    //     { name: 'نكهة', price: 6 },
    //     { name: 'عجمي ', price: 9 },
      
    //   ]
    }
    const Images = [
        
        "/assets/slider/00.jpeg",
        "/assets/slider/01.jpeg",
        "/assets/slider/02.jpeg",
        "/assets/slider/03.jpeg",
        "/assets/slider/04.jpeg",
        "/assets/slider/05.jpeg",
        "/assets/slider/06.jpeg",
        "/assets/slider/07.jpeg",
        "/assets/slider/08.jpeg",
        "/assets/slider/09.jpeg",
        "/assets/slider/10.jpeg",
        "/assets/slider/11.jpeg",
        "/assets/slider/12.jpeg",
        "/assets/slider/13.jpeg",
        "/assets/slider/14.jpeg",
        "/assets/slider/15.jpeg",
        "/assets/slider/16.jpeg",
        "/assets/slider/17.jpeg",
        "/assets/slider/18.jpeg",
        "/assets/slider/19.jpeg",
    ]


      const [activeCategory, setActiveCategory] = useState('سلطات');
      const [parent,setParent] = useState(' ');
      const handleClick = (category) => {
        setActiveCategory(category);
      }
  return (
    <>
    <HeadContainer>
        <span style={{cursor:"pointer"}} onClick={()=>{setParent(" ")}}>
        <Logo  />
        </span>
   
    <ParContainer>
        {Mains.map((item,i)=>(
            <ParBox key={i} onClick={()=>{setParent(item.label)}}>
                <ParSection>
                    <IconContainer>
                        <Icon src={item.icon} />
                    </IconContainer>
                </ParSection>
                <ParSection>
                    <Text>{item.title} </Text>
                </ParSection>
            </ParBox>
        ))}
   </ParContainer>
    </HeadContainer>

  
    <div className="App" style={{ textAlign: 'right' }}>
       {parent === ' ' && 
    //    <Wellcome/>
    <SliderContainer>
        <WellcomeSlider images={Images} slideInterval={2000} />
    </SliderContainer>
       
       }
       {parent === 'food' && 
       <>
       <div className="tabs">
        {Foods.map(category => (
          <button 
            key={category.name}
            className={category.name === activeCategory ? 'active' : ''}
            onClick={() => handleClick(category.name)}
          >
            {category.name}
          </button>
        ))}
      </div>
      <SliderContainer style={{marginBottom:"2rem"}}>
        <WellcomeSlider images={Images} slideInterval={2000} />
      </SliderContainer>
      {Foods.map(category => (
        <div 
          key={category.name} 
          className={`category ${category.name === activeCategory ? 'active' : ''}`}
        >
          {category.items.map(item => (
            <div key={item.name} className="item">
                <div className="name" style={{textAlign:'left'}}>{item.nameAr}</div>
              <div className="price">${item.price}</div>
              <div className="name">{item.name}</div>
             
            </div>
          ))}
        </div>
          ))}
      </>
      }
      {
        parent === 'drink' && 
        <>
            {Drinks.items.map(item => (
            <div key={item.name} className="item">
              <div className="name" style={{textAlign:"left"}}>{item.nameAr}</div>
              <div className="price">${item.price}</div>
              <div className="name">{item.name}</div>
             
            </div>
          ))}
        </>
      }
      {
        parent === 'shisha' && 
        <>
            {Shisha.items.map(item => (
            <div key={item.name} className="item">
              <div className="price">${item.price}</div>
              <div className="name">{item.name}</div>
             
            </div>
          ))}
        </>
      }
          </div>
    <Footer>
        <FooterContent>
        <FooterItem>
            <a href='tel:009613608338' style={{textDecoration:'none', color:'inherit'}}>
                <Wa/> 03608338
            </a>
                
            </FooterItem>
            <FooterItem onClick={()=>{
                window.open('https://www.instagram.com/sondos.resto/?igshid=YmMyMTA2M2Y=')
            }}>
                <IG/> @sondos.resto
            </FooterItem>
            <FooterItem onClick={()=>{
                window.open('https://www.facebook.com/sondosreat?mibextid=LQQJ4d')
            }}>
                <FB/> Sondos REST
            </FooterItem>
           
        </FooterContent>
    </Footer>
          </>
  )
}
